import React, { useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Ourhome from "./pages/Ourhome";
import Weprovide from "./pages/Weprovide";
import Childrenhelp from "./pages/Childrenhelp";
import Footer from "./Component/Footer";
import Header2 from "./Component/header2";
import OurApproch from "./pages/OurApproch";
import SafeguardingQuality from "./pages/SafeguardingQuality";
import Referrals from "./pages/Referrals";
import Careers from "./pages/Careers";
import ForestView from "./pages/ForestView";
import SpringHouse from "./pages/SpringHouse";
import RiseHouse from "./pages/RiseHouse";
import HomeDetails from "./pages/HomeDetails";

import Lenis from "lenis";
import AOS from "aos";
import "aos/dist/aos.css";

function ScrollToTop({ lenis }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (lenis.current) {
      lenis.current.scrollTo(0, { immediate: true });
    }
  }, [pathname, lenis]);

  return null;
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: false,
      mirror: true,
    });

    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      lerp: 0.07,
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Refresh AOS on scroll
    lenis.on("scroll", () => {
      AOS.refresh();
    });

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Header2 />

      {/* Scroll Reset on Route Change */}
      <ScrollToTop lenis={lenisRef} />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />

        <Route path="/ourhome" element={<Ourhome />} />
        <Route path="/ourhome/:id" element={<HomeDetails />} />

        <Route path="/weprovide" element={<Weprovide />} />
        <Route path="/childrenhelp" element={<Childrenhelp />} />
        <Route path="/contact" element={<Contact />} />

        <Route path="/ourapproch" element={<OurApproch />} />
        <Route path="/safeguardingquality" element={<SafeguardingQuality />} />
        <Route path="/referrals" element={<Referrals />} />
        <Route path="/careers" element={<Careers />} />

        <Route path="/forestview" element={<ForestView />} />
        <Route path="/springhouse" element={<SpringHouse />} />
        <Route path="/risehouse" element={<RiseHouse />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
